















import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import Vue from 'vue';

import HeaderMixins from './mixins';
import { mapState, mapGetters } from 'vuex';

import('@/assets/header/' + process.env.VUE_APP_CLIENT + '/' + process.env.VUE_APP_THEME + '/style.scss').catch((e) => {
  import('@/assets/header/' + process.env.VUE_APP_CLIENT + '/style.scss');
});

@Component({
  computed: {
    ...mapState({
      HeaderTitle: 'Header',
    }),
  },
})
export default class Header extends mixins(Vue, HeaderMixins) {
  public showTitle: boolean = true;

  public HeaderTitle!: string;

  mounted() {
    if (process.env.VUE_APP_CLIENT === 'test') {
      this.showTitle = false;
    }
  }
  get title() {
    if (this.$route.name == 'Login') {
      if (process.env.VUE_APP_CLIENT === 'veidaya') {
        return 'ועידת יש עתיד 2024 בחירות לתפקיד יו"ר המפלגה';
      }
      if (process.env.VUE_APP_CLIENT === 'ashdodport') {
        return 'בחירות לנציגים מקרב העובדים לדירקטוריון';
      }
      if (process.env.VUE_APP_CLIENT === 'tenenoga') {
        return 'בחירות לועד העובדים טנא נגה';
      }
    }

    return (this.showTitle && this.HeaderTitle) || '';
  }
}
